import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';
import EventsList from './EventsList';

const GetInvolved = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const isValidEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !isValidEmail(email)) {
            setMessage('Please enter a valid email address.');
            return;
        }

        try {
            await addDoc(collection(db, 'subscribers'), {
                email,
                timestamp: new Date().toISOString()
            });
            setMessage('Thank you for signing up!');
            setEmail('');
        } catch (error) {
            setMessage('Error signing up. Please try again.');
            console.error('Error adding email:', error);
        }
    };

    return (
        <section id="getinvolved" className="py-20 px-4 bg-white border-t border-gray-100">
            <div className="max-w-6xl mx-auto">

                {/* Section header */}
                <div className="text-center mb-14">
                    <h2 className="text-3xl font-bold text-black uppercase tracking-wide mb-3">
                        Get Involved
                    </h2>
                    <div className="flex justify-center mb-5">
                        <div className="w-16 border-b-4 border-black rounded-full"></div>
                    </div>
                    <p className="text-gray-500 text-lg max-w-xl mx-auto">
                        Stay in the loop — sign up to hear about upcoming events and ways to get involved.
                    </p>
                </div>

                {/* Email sign-up */}
                <div className="max-w-lg mx-auto mb-16" data-aos="fade-up">
                    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
                        <input
                            type="email"
                            placeholder="Enter your email address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="flex-1 px-4 py-3 border border-gray-200 rounded-xl text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-base"
                            required
                        />
                        <button
                            type="submit"
                            className="bg-black text-white py-3 px-7 rounded-xl hover:bg-gray-800 transition-colors font-medium text-base whitespace-nowrap"
                        >
                            Sign Up
                        </button>
                    </form>
                    {message && (
                        <p className={`mt-3 text-sm text-center ${message.includes('Thank') ? 'text-green-600' : 'text-red-500'}`}>
                            {message}
                        </p>
                    )}
                </div>

                {/* Events list */}
                <div data-aos="fade-up" data-aos-delay="200">
                    <EventsList />
                </div>

            </div>
        </section>
    );
};

export default GetInvolved;
